<template>
  <div class="text-xs-center my-5">
    <h1>{{ $t('pageNotFound.title') }}</h1>
    <p>{{ $t('pageNotFound.pageNotFound') }}</p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PageNotFound.vue?6aea5d1b